/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetDecimalsFormats$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDecimalsFormatsRequest = createAction<PayloadData<void>>('GET_DECIMALS_FORMATS__GET_DECIMALS_FORMATS__REQUEST');
export const getDecimalsFormatsSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_DECIMALS_FORMATS__GET_DECIMALS_FORMATS__SUCCESS');
export const getDecimalsFormatsFailure = createAction<PayloadData<Error, void, true>>('GET_DECIMALS_FORMATS__GET_DECIMALS_FORMATS__FAILURE');

export const getDecimalsFormatsActions = [
    getDecimalsFormatsRequest,
    getDecimalsFormatsSuccess,
    getDecimalsFormatsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDecimalsFormats = (config?: GetDecimalsFormats$Config) => {
    return {
        CALL_API: {
            types: getDecimalsFormatsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/decimals-formats`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

